import React from 'react';

import HeaderContainer from 'containers/HeaderContainer';
import OrderSettingsContainer from 'containers/OrderSettingsContainer';

import Footer from 'views/Footer';

class OrderSettingsPage extends React.Component {
	render() {
		const orderId = this.props.match.params.orderId;
		return (<div>
					<HeaderContainer />
					<OrderSettingsContainer orderId={orderId} />
					<Footer />
				</div>
			);
		
	}
}


export default OrderSettingsPage;


// WEBPACK FOOTER //
// ./src/pages/OrderSettingsPage.js